export default {
    Region: process.env.COGNITO_REGION,
    UserPoolId: process.env.COGNITO_USER_POOL_ID,
    ClientId: process.env.COGNITO_CLIENT_ID
}



// WEBPACK FOOTER //
// ./src/config.js